import * as React from "react";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../../gvc/testNewForm/CpDescription";
import { formSetValue } from "../../../gvc/testNewForm/utils";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";

interface Props {}
export const ProviderGCP: React.FC<Props> = () => {
  const { id } = useCpFormContext();

  return (
    <>
      <CardTitle>
        GCP
        <CpErrorWarningArrayIcon names={["gcp"]} />
      </CardTitle>
      <CardContent>
        <CpFormItem>
          <CpLabel name={"gcp.projectId"}>Project ID</CpLabel>
          <CpDescription>
            <div>
              Click{" "}
              <span
                className="cursor-pointer"
                style={{ color: "var(--color-blue-400)" }}
                onClick={() => {
                  formSetValue(id, "meta.drawer", "provider-gcp-project-id");
                }}
              >
                here
              </span>{" "}
              to learn how to get your GCP Project ID.
            </div>
          </CpDescription>
          <CpInput name={"gcp.projectId"} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={"gcp.projectId"} />
        </CpFormItem>
      </CardContent>
    </>
  );
};
